import { smallOnly } from '/imports/ui/stylesheets/styled-components/breakpoints';
import styled from 'styled-components';

import {
  borderRadius,
  lgPaddingX,
} from '/imports/ui/stylesheets/styled-components/general';
import {
  fontSizeSmall,
  fontSizeBase,
  fontSizeLarge,
  headingsFontWeight,
  lineHeightComputed,
} from '/imports/ui/stylesheets/styled-components/typography';
import {
  colorWhite,
  colorText,
  colorBackground,
  colorPrimary,
  // colorGray,
  colorGrayLight
} from '/imports/ui/stylesheets/styled-components/palette';

const Parent = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color : #EEF0F2
  // background-color: ${colorBackground};
`;

const Modal = styled.div`
  display: flex;
  padding: ${lgPaddingX};
  background-color: ${colorWhite};
  flex-direction: column;
  border-radius: ${borderRadius};
  max-width: 95vw;
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
`;

const Content = styled.div`
  text-align: center;
`;

const Title = styled.h1`
  margin: 0;
  font-size: ${fontSizeLarge};
  font-weight: ${headingsFontWeight};
`;

const Text = styled.div`
  color: ${colorText};
  font-weight: normal;
  padding: ${lineHeightComputed} 0;

  @media ${smallOnly} {
    font-size: ${fontSizeSmall};
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FeedbackForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: left;
  padding: 12px 8px;
`;

const FeedbackHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;
`;

const FeedbackTitle = styled.h1`
  font-size: 26px;
  font-weight: 700;
  color: #00265e;
  margin: 0 0 10px 0;
`;

const FeedbackIntro = styled.p`
  font-size: 15px;
  color: #4b5563;
  margin: 0;
`;

const QuestionGroup = styled.div`
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 24px;
  }
`;

const QuestionLabel = styled.label`
  display: block;
  font-size: 15px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

const RatingHint = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #9ca3af;
  margin-bottom: 8px;
  padding: 0 4px;
`;

const SelectWrapper = styled.div`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid #6b7280;
    pointer-events: none;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 10px 36px 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  background-color: #fff;
  cursor: pointer;
  appearance: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  color: #374151;

  &:focus {
    outline: none;
    border-color: #00ce77;
    box-shadow: 0 0 0 2px rgba(0, 206, 119, 0.1);
  }

  &:hover {
    border-color: #d1d5db;
  }
`;

const FeedbackTextArea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  resize: none;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    outline: none;
    border-color: #00ce77;
    box-shadow: 0 0 0 2px rgba(0, 206, 119, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  color: #fff;
  background-color: #00ce77;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #00b568;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const MeetingEndedButton = styled.button`
  border: none;
  overflow: visible;
  border-radius: 2px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  height: 2.5rem;
  display: flex !important;
  align-items: center;
  box-align: center;
  flex-align: center;
  box-pack: center;
  justify-content: center;
  flex-pack: center;
  color: var(--btn-primary-color, var(--color-white, #FFF));
  background-color: var(--btn-primary-bg, var(--color-primary, ${colorPrimary}));
  border: 3px solid transparent;
  padding: calc(1.25rem / 2);
  @media ${smallOnly} {
    font-size: ${fontSizeBase};
  }
     &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    background-color: #ccc; /* fallback dim color if needed */
  }
`;

const TextArea = styled.textarea`
  resize: none;
  margin: 1rem auto;
  width: 80%;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  // resize: none;
  // margin: 1rem auto;
  // width: 100%;

  &::placeholder {
    // text-align: center;
    color: ${colorGrayLight};
    opacity: 1;
  }
`;

export default {
  Parent,
  Modal,
  Content,
  Title,
  Text,
  MeetingEndedButton,
  TextArea,
  Wrapper,
  FeedbackForm,
  FeedbackHeader,
  FeedbackTitle,
  FeedbackIntro,
  QuestionGroup,
  QuestionLabel,
  RatingHint,
  SelectWrapper,
  Select,
  FeedbackTextArea,
  SubmitButton,
};
